import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
    AtualizarCategoriaAtendimentoController,
    DeletarCategoriaAtendimentoController,
    ListarCategoriaAtendimentosController,
} from "../../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import { ICategoriaAtendimento } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { ACESSOS } from "../../../../../../Routes/Acessos";
import SpinnerComponent from "../../../../../Loding/Spinner";
import ModalComponent from "../../../../../Modais";
import { IComponentModal } from "../../../../../Modais/IModalComponent";
import Table from "../../../../../Table";
import CadastrarCategoria from "./CadastrarCategoria";
import { Tab, Tabs } from "react-bootstrap";

export default function GestaoCategoriaAtendimento() {
    const [lstCategorias, setlstCategorias] = useState(
        [] as Array<ICategoriaAtendimento>
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    useEffect(() => {
        updateList();
    }, []);

    function updateList() {
        ListarCategoriaAtendimentosController().then((response) => {
            setlstCategorias(response);
        });
    }

    const lstCategoriasAtivas = lstCategorias.filter(
        (categoria) => categoria.FL_ATIVO
    );

    const lstCategoriasInativas = lstCategorias.filter(
        (categoria) => !categoria.FL_ATIVO
    );

    function RowTable(row: ICategoriaAtendimento) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_CATEGORIA_ATENDIMENTO_COMP}</h4>
                        <div>
                            {row.FL_ATIVO ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    {" "}
                                    Ativado
                                </span>
                            ) : (
                                <span className="label label-danger abel-pill label-inline mr-2">
                                    Desativado
                                </span>
                            )}

                            {row.FL_ATIVO_PORTAL ? (
                                <span className="label abel-pill label-inline label-success mr-2">
                                    Ativo no Portal
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-tools">
                        <div className="toolsTable">
                            <label className="text-white">Capys Tools</label>
                            <div className="tools-capys">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO
                                                ? "Desativar Categoria"
                                                : "Ativar Categoria"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-success"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_ATIVO_STATUS"
                                                name="FL_ATIVO"
                                                checked={row.FL_ATIVO}
                                                type="checkbox"
                                                onChange={() => {
                                                    AtualizarCategoriaAtendimentoController(
                                                        {
                                                            ...row,
                                                            FL_ATIVO:
                                                                !row.FL_ATIVO,
                                                        }
                                                    ).then(updateList);
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO_PORTAL
                                                ? "Desativar Atendimento no Portal"
                                                : "Ativar Atendimento no Portal"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-info"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_ATIVO_PORTAL_STATUS"
                                                name="FL_ATIVO_PORTAL"
                                                checked={row.FL_ATIVO_PORTAL}
                                                type="checkbox"
                                                onChange={() => {
                                                    AtualizarCategoriaAtendimentoController(
                                                        {
                                                            ...row,
                                                            FL_ATIVO_PORTAL:
                                                                !row.FL_ATIVO_PORTAL,
                                                        }
                                                    ).then(updateList);
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {row.FL_ATIVO_PORTAL
                                                ? "Desativar Limite de Atendimento por Cliente - Produto"
                                                : "Ativar Limite de Atendimento por Cliente - Produto"}
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className="switch switch-outline switch-sm switch-icon switch-warning"
                                        data-toggle="tooltip"
                                    >
                                        <label>
                                            <input
                                                id="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA_STATUS"
                                                name="FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA"
                                                checked={
                                                    row.FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA
                                                }
                                                type="checkbox"
                                                onChange={() => {
                                                    AtualizarCategoriaAtendimentoController(
                                                        {
                                                            ...row,
                                                            FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA:
                                                                !row.FL_BLOCK_ABERTURA_ATENDIMENTO_CONTA_PRODUTO_CATEGORIA,
                                                        }
                                                    ).then(updateList);
                                                }}
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="Button-Tools">
                            {row.ID_CATEGORIA_ATENDIMENTO && (
                                <Link
                                    className="btn btn-outline-primary font-weight-bold mr-2 d-flex align-items-center"
                                    to={ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.EDITAR.DS_LINK(
                                        row.ID_CATEGORIA_ATENDIMENTO
                                    )}
                                >
                                    <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                    Editar
                                </Link>
                            )}

                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar este categoria?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                            DeletarCategoriaAtendimentoController(
                                                row.ID_CATEGORIA_ATENDIMENTO ??
                                                    0
                                            ).then(() => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const ColunsCategoria: Array<ColumnDescription<ICategoriaAtendimento>> = [
        {
            dataField: "DS_CATEGORIA_ATENDIMENTO_COMP",
            text: "Descrição",
            formatter: (c, row) => <RowTable {...row} />,
            sort: true,
        },
    ];

    return lstCategorias.length ? (
        <>
            <div className="card card-custom" id="kt_page_sticky_card">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            Categorias de Atendimento
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () => (
                                        <CadastrarCategoria
                                            setShow={setShow}
                                            updateList={updateList}
                                        />
                                    ),
                                    noFooter: true,
                                    noHeader: true,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />{" "}
                            Nova Categoria
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <Tabs defaultActiveKey="ativas" id="categorias-tabs">
                        <Tab eventKey="ativas" title="Ativas">
                            <div className="table-responsive-sm">
                                <Table
                                    keyField="ID_CATEGORIA_ATENDIMENTO"
                                    data={lstCategoriasAtivas}
                                    columns={ColunsCategoria}
                                />
                            </div>
                        </Tab>
                        <Tab eventKey="inativas" title="Inativas">
                            <div className="table-responsive-sm">
                                <Table
                                    keyField="ID_CATEGORIA_ATENDIMENTO"
                                    data={lstCategoriasInativas}
                                    columns={ColunsCategoria}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </div>
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
